import { useMediaQuery } from "native-base";
import LoginPageMobileResponsive from "./mobileResponsive";
import LoginPageWeb from "./web";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

const Login = () => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const getComponents = () => {
    if (isSmallScreen) {
      return <LoginPageMobileResponsive />;
    } else {
      return <LoginPageWeb />;
    }
  };

  return <>{getComponents()}</>;
};

export default Login;
